// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDYrUTh7LezcOr1u5vs_X-0E9YVIH48qeA",
  authDomain: "el4-node-rest-service.firebaseapp.com",
  databaseURL: "https://el4-node-rest-service.firebaseio.com",
  projectId: "el4-node-rest-service",
  storageBucket: "el4-node-rest-service.appspot.com",
  messagingSenderId: "316927155108",
  appId: "1:316927155108:web:910b446bb1c1075c07bf31",
  measurementId: "G-5H54ZJF56G"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

